import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useResetRecoilState, useRecoilValue } from 'recoil';
import { authState } from '../RecoilStore';
import './AdminLayout.scss';

function AdminLayout() {
  const navigate = useNavigate();
  const auth = useRecoilValue(authState);
  const resetAuth = useResetRecoilState(authState);

  const NAV_ITEMS = [
    { to: '/admin/stores', label: '매장 관리' },
    ...(auth?.isMasterAdmin ? [{ to: '/admin/pending-admins', label: '관리자 승인' }] : []),
  ];

  const handleLogout = () => {
    resetAuth();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="AdminLayout">
      <nav className="AdminLayout-sidebar">
        <h1 className="AdminLayout-title">카페앱모아 전체 관리자</h1>
        <ul>
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <button className="AdminLayout-home" onClick={() => navigate('/')}>
          홈
        </button>
        <button className="AdminLayout-logout" onClick={handleLogout}>
          로그아웃
        </button>
      </nav>
      <main className="AdminLayout-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
